<template lang="pug">
canvas#water-layer(ref='water')
//-div
  pre {{ {posX, posY, currentX, currentY, exit } }}
</template>

<script>
let RC = () => "#" + Math.floor(Math.random() * 16777215).toString(16)

import * as canvasTiles from "@/canvas"

import { sleep } from "@/utils"
import CanvasMixin from "./CanvasMixin"
let wc = null
export default {
  name: "WaterCanvas",
  components: {},
  mixins: [CanvasMixin],
  props: {
    board: { type: Array },
    //start: { type: Object },
    instant: { type: Boolean }
  },
  data() {
    return {
      size: canvasTiles.f,
      position: { x: null, y: null },
      exit: null,
      running: false,
      currentX: 0,
      currentY: 0
    }
  },
  watch: {
    start: {
      handler(point) {
        console.log("START changed", point)

        this.position = point || { x: 0, y: 0 }
        this.setStartPosition()
      }
    }
  },
  mounted() {
    this.canvasKey = "water"
    this.onInitialize = this.initializeWater
  },
  methods: {
    async initializeWater(ctx) {
      wc = ctx

      //wc.translate(this.scaledDrop * 0.5, this.scaledDrop * 0.5)
      wc.fillStyle = "darkblue"

      console.log("initializeWater", this.position)
      if (this.position.x !== null) {
        this.setStartPosition()
      } else {
        this.position = { x: 0, y: 0 }
      }
      // setTimeout(() => this.startWater(), 1500)
    },
    moveTo({ tx = 0, ty = 0, sx = 0, sy = 0, px = 0, py = 0, sz = 2 } = {}) {
      try {
        let _x = tx * this.scaledTile + sx * this.scaledDrop * 2 + px * this.point
        let _y = ty * this.scaledTile + sy * this.scaledDrop * 2 + py * this.point
        let pt = this.point * sz
        wc.fillRect(_x, _y, pt, pt)
        this.posX = _x
        this.posY = _y
      } catch (e) {
        console.error("Move To Error", e)
      }
    },
    setStartPosition() {
      console.log("setStartPosition", this.position)
      this.resetBoard()

      this.currentX = this.position.x
      this.currentY = this.position.y
      this.posX = 2
      this.posY = 2

      this.moveTo({ tx: this.position.x, ty: this.position.y, sx: 1, sy: 1, px: 1, py: 1 })
      //this.drawPoint()
    },
    async startWater() {
      if (this.posX == null || this.posY == null) this.setStartPosition()
      await this.drawWater()

      //this.isRunning = !this.running
      //this.$store.commit("toggleRunning")
    },
    resetBoard() {
      wc.clearRect(0, 0, wc.canvas.width, wc.canvas.height)
    },
    addPoint() {
      //this.$emit("addPoint")
      this.$state.score += 2
    },

    // async drawTub(d) {
    //   let { w, hf, hw, tubPath, m } = canvasTiles
    //   let o = this.size * 2 - w
    //   let { posX, posY, instant, size } = this
    //   let step = instant ? 5 : 1
    //   let wait = instant ? 5 : this.waterSpeed
    //   let dist = Math.floor(Math.abs(o) / Math.abs(step))

    //   this.$state.score += 220

    //   wc.save()
    //   //wc.translate(originX, this.currentY * size)
    //   //wc.clip(tubPath)
    //   //wc.clearRect(0, 0, 120, 60)
    //   wc.fillStyle = "rgba(6,0,255,.3)"

    //   for (var i = 0; i < dist; i++) {
    //     if (d == "r") this.x++
    //     else if (d == "l") this.x--
    //     else if (d == "u") this.y--
    //     else if (d == "d") this.y++
    //     wc.fillRect(this.posX - w, this.posY - m, w, size)
    //     //// wc.fillRect(x, y, w, size)
    //     //x += step
    //     await sleep(wait)
    //     this.addPoint()
    //   }
    //   wc.restore()

    //   //this.posX = originX + x * (d === "r" ? 1 : -1)

    //   await sleep(5000)
    // },
    async move(dir, dist, func) {
      // half point
      let hp = this.point
      // full point
      let pt = this.point * 2
      let wait = this.$state.lag
      let sp = this.$state.step
      //debugger
      try {
        let i = 0

        let _h, _w, _x, _y
        // starting height / width
        let h = 0
        let w = 0
        // base height / width to account for going negative
        let bh = dir == "l" || dir === "r" ? pt : 0
        let bw = dir == "u" || dir === "d" ? pt : 0
        // base x / y coordinates
        let bx = dir === "r" ? pt : 0
        let by = dir === "d" ? pt : 0
        // testing with random color
        if (this.$state.rainbow) wc.fillStyle = RC()
        _x = this.posX + bx
        _y = this.posY + by
        if (this.$state.isInstant) {
          let n = dir == "u" || dir === "l" ? -1 : 1
          _w = dir == "l" || dir === "r" ? dist * pt * n : bw
          _h = dir == "u" || dir === "d" ? dist * pt * n : bh

          if (dir == "u") h--
          else if (dir == "d") h++
          else if (dir == "l") w--
          else if (dir == "r") w++

          wc.fillRect(_x, _y, _w, _h)
          await sleep(1)
          this.$state.score += dist * 4
        } else
          while (i++ < dist * 2 * sp) {
            if (dir == "u") h--
            else if (dir == "d") h++
            else if (dir == "l") w--
            else if (dir == "r") w++
            _h = (h * hp) / sp + bh
            _w = (w * hp) / sp + bw

            ///console.log({ dir, dist, _x, _y, _h, _w })
            if (typeof func === "function") func(_x, _y, _w, _h)
            else wc.fillRect(_x, _y, _w, _h)

            if (i % sp === 0) this.addPoint()
            if (!this.$state.isInstant) await sleep(wait)
            while (this.$state.isPaused) await sleep(500)
          }
        // update position for next turn
        if (dir == "u") this.posY += _h
        else if (dir == "d") this.posY += _h
        else if (dir == "l") this.posX += _w
        else if (dir == "r") this.posX += _w
      } catch (e) {
        console.warn(e)
      }
    },
    async drawWater() {
      while (this.$state.isPaused) await sleep(500)
      //console.log("drawWater", this.currentP)
      let p = null
      try {
        p = this.currentP.c

        this.currentP.m++

        console.log("drawing water", {
          p,
          valid: this.valid,
          isRunning: this.isRunning,
          exit: this.exit
        })

        switch (p) {
          case "dr":
            await this.move("l", 3.5, p)
            break
          case "dl":
            await this.move("r", 3.5, p)
            break
          case "dt":
            await this.move("d", 3.5, p)
            break
          case "db":
            await this.move("u", 3.5, p)
            break
          case "sl":
            await this.move("l", 2.5, p)
            this.currentX--
            this.exit = 9
            break
          case "sr":
            await this.move("r", 2.5)
            this.currentX++
            this.exit = 3
            break
          case "ibr":
          case "br":
            if (this.exit == 3) {
              await this.move("r", 3.5, p)
              await this.move("u", 2.5, p)
              this.currentY--
              this.exit = 12
            } else {
              await this.move("d", 3.5, p)
              await this.move("l", 2.5, p)
              this.currentX--
              this.exit = 9
            }
            break
          case "ibl":
          case "bl":
            if (this.exit == 6) {
              await this.move("d", 3.5, p)
              await this.move("r", 2.5, p)
              this.currentX++
              this.exit = 3
            } else if (this.exit == 9) {
              await this.move("l", 3.5, p)
              await this.move("u", 2.5, p)
              this.currentY--
              this.exit = 12
            }

            break
          case "itl":
          case "tl":
            if (this.exit == 9) {
              await this.move("l", 3.5, p)
              await this.move("d", 2.5, p)
              this.currentY++
              this.exit = 6
            } else {
              await this.move("u", 3.5, p)
              await this.move("r", 2.5, p)
              this.currentX++
              this.exit = 3
            }
            break
          case "itr":
          case "tr":
            if (this.exit == 3) {
              await this.move("r", 3.5, p)
              await this.move("d", 2.5, p)
              this.currentY++
              this.exit = 6
            } else {
              await this.move("u", 3.5)
              await this.move("l", 2.5)
              this.currentX--
              this.exit = 9
            }
            break
          case "jv":
            if (this.exit == 12) {
              await this.move("u", 2, p)
              await this.move("l", 2, p)
              await this.move("u", 1.5, p)
              await this.move("r", 4, p)
              await this.move("u", 1.5, p)
              await this.move("l", 2, p)
              await this.move("u", 1, p)
              this.currentY--
            } else if (this.exit == 6) {
              await this.move("d", 2, p)
              await this.move("r", 2, p)
              await this.move("d", 1.5, p)
              await this.move("l", 4, p)
              await this.move("d", 1.5, p)
              await this.move("r", 2, p)
              await this.move("d", 1, p)
              this.currentY++
            }

            break
          case "jh":
            if (this.exit == 9) {
              await this.move("l", 2)
              await this.move("d", 2)
              await this.move("l", 1.5)
              await this.move("u", 4)
              await this.move("l", 1.5)
              await this.move("d", 2)
              await this.move("l", 1)
              this.currentX--
            } else if (this.exit == 3) {
              await this.move("r", 2)
              await this.move("u", 2)
              await this.move("r", 1.5)
              await this.move("d", 4)
              await this.move("r", 1.5)
              await this.move("u", 2)
              await this.move("r", 1)
              this.currentX++
            }

            break
          case "lv":
            if (this.exit == 12) {
              await this.move("u", 6, p)
              this.currentY--
            } else {
              await this.move("d", 6, p)
              this.currentY++
            }
            break
          case "tul":
          case "tur":
            if (this.exit == 3) {
              await this.move("r", 6, p)
              this.currentX++
            } else {
              await this.move("l", 6, p)
              this.currentX--
            }
            // since this will get added twice one per piece we will do half the total
            this.$state.score += 100
            break
          case "lh":
            if (this.exit == 3) {
              await this.move("r", 6, p)
              this.currentX++
            } else {
              await this.move("l", 6, p)
              this.currentX--
            }
            break
          case "cr":
            if (this.exit == 3) {
              await this.move("r", 3, p)
              if (this.currentP.m == 2) this.$state.loops++
              await this.move("r", 3, p)
              this.currentX++
            } else if (this.exit == 6) {
              await this.move("d", 3, p)
              if (this.currentP.m == 2) this.$state.loops++
              await this.move("d", 3, p)
              this.currentY++
            } else if (this.exit == 9) {
              await this.move("l", 3, p)
              if (this.currentP.m == 2) this.$state.loops++
              await this.move("l", 3, p)
              this.currentX--
            } else {
              await this.move("u", 3, p)
              if (this.currentP.m == 2) this.$state.loops++
              await this.move("u", 3, p)
              this.currentY--
            }
            break
          // case "tur":
          // case "tul":
          //   wc.save()
          //   wc.translate(this.positionX * f, this.positionY * f)
          //   wc.clip(canvasTiles.tubPath)
          //   wc.fillRect(0, 0, 500, 500)
          //   wc.restore()
          //   if (this.exit == 3) {
          //     await this.draw("r", w + hw)
          //     wc.fillStyle = "red"
          //     await this.draw("r", f * 2 - w, p)
          //     wc.fillStyle = "darkblue"
          //     await this.draw("r", w)
          //     this.currentX += 2
          //   } else {
          //     await this.draw("l", w + hw)
          //     wc.fillStyle = "red"
          //     await this.draw("l", f * 2 - w, p)
          //     wc.fillStyle = "darkblue"
          //     await this.draw("l", w)
          //     this.currentX -= 2
          //   }
          //   break
          default:
            break
        }

        if (p == null || p.startsWith("d") || (!this.valid && p !== "sr" && p !== "sl")) {
          //this.$store.commit("setRunning", { value: false })
          this.$state.hasFinished = true
          console.log("!!!", { currentP: this.currentP.c, exit: this.exit })
          return
        }
        //if (this.$state.isRunning)
        else await this.drawWater()
      } catch (e) {
        console.warn("DRAW WATER", e)
      }
    },

    isValid(e) {
      let p = this.currentP
      if (!p || !e) return false
      if (p.l === true) return false // locked
      return (
        (e == 3 && ["dl", "cr", "lh", "jh", "tr", "br", "ibr", "itr", "tur", "tul"].includes(p.c)) ||
        (e == 6 && ["dt", "cr", "lv", "jv", "br", "bl", "ibl", "ibr"].includes(p.c)) ||
        (e == 9 && ["dr", "cr", "lh", "jh", "tl", "bl", "itl", "ibl", "tur", "tul"].includes(p.c)) ||
        (e == 12 && ["db", "cr", "lv", "jv", "tl", "tr", "itl", "itr"].includes(p.c))
      )
    }
  },
  computed: {
    start() {
      return this.$state.start
    },
    isRunning() {
      return this.$state.isRunning
    },
    currentP() {
      if (this.board === undefined) return null

      let row = this.board[this.currentX]

      if (row) return row[this.currentY]

      return null
    },
    valid() {
      return this.isValid(this.exit)
    },
    point() {
      return this.scaledTile / 12
    }
  }
}
</script>

<style lang="scss" scoped></style>
